import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Seo from "../components/Seo";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { sized, srcSet } from "../lib/api";
import { useContent } from "../context/ContentContext";

export default function HowWeMake() {
  const { p } = useContent();
  const c = p("how_we_make");
  const STEPS = c.steps.items || [];
  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14" data-testid="how-we-make-page">
      <Seo title="How We Make an Etching — CaminoSapiens" description="A step-by-step look at how we make a hand-pulled photogravure etching, from photograph to signed print." />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "How We Make an Etching" }]} />
      <div className="max-w-2xl mb-16">
        <p className="overline mb-4">{c.intro.eyebrow}</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight">{c.intro.heading}</h1>
        <p className="text-[#4A4947] mt-6 leading-relaxed">{c.intro.body}</p>
      </div>

      <div className="space-y-24">
        {STEPS.map((s, i) => {
          const num = s.n || String(i + 1).padStart(2, "0");
          return (
            <motion.div key={num || i} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}
              className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`} data-testid={`process-step-${num}`}>
              <div className="overflow-hidden border border-[#E4E1DB] [direction:ltr]">
                <img src={sized(s.img, 1000)} srcSet={srcSet(s.img, [500, 800, 1200])} sizes="(min-width:1024px) 50vw, 100vw" alt={s.alt || s.t} className="w-full h-[420px] object-cover" loading="lazy" />
              </div>
              <div className="[direction:ltr]">
                <span className="font-display text-6xl text-[#B35D4B]/40">{num}</span>
                <h2 className="font-display text-3xl mt-2">{s.t}</h2>
                <p className="text-[#4A4947] mt-4 leading-relaxed text-lg">{s.d}</p>
              </div>
            </motion.div>
          );
        })}
      </div>

      <div className="text-center mt-24 bg-[#F0EFEA] border border-[#E4E1DB] py-16 px-6">
        <h2 className="font-display text-3xl">{c.cta.heading}</h2>
        <p className="text-[#4A4947] mt-3">{c.cta.body}</p>
        <Link to={c.cta.cta_link} className="inline-block bg-[#1C1B1A] text-[#F9F8F6] px-8 py-4 text-sm mt-6 hover:bg-[#B35D4B] transition-colors">{c.cta.cta_label}</Link>
      </div>
    </div>
  );
}
